import { gql } from "@apollo/client"

export const GET_CUSTOMER_CARDS = gql`
  query RetriveCustomerCards($stripeId: String) {
    retriveCustomerCards(stripe_id: $stripeId) {
      id
      exp_month
      exp_year
      last4
      brand
      funding
    }
  }
`